export function waitTime(time: number) {
    return new Promise<void>((resolve) => {
        setTimeout(() => resolve(), time);
    });
}
